import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendrier-visites',
  templateUrl: './calendrier-visites.component.html',
  styleUrls: ['./calendrier-visites.component.css']
})
export class CalendrierVisitesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
